import React from "react";
import { Row, Col, Card, Button } from "antd";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { VscLinkExternal } from "react-icons/vsc";
import CustomerImage from "../../assets/images/contractor-dashboard-instructions.png";
import Cookies from "universal-cookie";

const cookies = new Cookies();
const NavigationWrapper = styled(Card)`
  min-height: 280px;
  background-color: white;
  border-radius: 0;
  border: 0px solid #e0e0e0;
  box-shadow: 0px 0px 5px 0px rgb(0 0 0 / 16%);
  margin-top: 15px;
  margin-right: 10px;
  .nav-heading{
    font-size:0.9rem;
    margin: 0 0 15px 0;
     font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
     font-weight: 600;
     color: #444444;
     text-transform: none;

  }
  .collection-header{
    background-color: #fff;
    padding: 15px;
  }
  .item-link{
    inline-block;
    padding: 10px 20px 7px;
    border-left: 5px solid transparent;
    font-weight:500;
}
  
.item-link:hover{
    color:#09c1b2 !important;
    cursor:pointer;
    border-color:#09c1b2 !important
}
.item-active{
    color:#09c1b2 !important;
    border-color:#09c1b2 !important
    padding: 10px 20px 7px !important;
  
} 

`;
const ButtonWrapper = styled(Card)`
  min-height: 50px;
  height: 10px;
  background-color: ${(props) => props.background};
  margin: 0;
  padding: 1rem;
  display: flex;
  cursor: pointer;
  align-items: center;
`;
export default function NavigationCard(props) {
  const pathname = props?.location?.pathname;
  const history = useHistory();
  var childwin;
  const childname = "popup";
  const sendMessage = () => {
    childwin = window.open(
      "http://contractor.api-stg2.surface-tech.com/rmx",
      childname,
      "height=300px, width=500px"
    );
    let msg = window.localStorage.getItem("access_token_contractor");
    // In production, DO NOT use '*', use toe target domain
    childwin.postMessage(msg, "*"); // childwin is the targetWindow
    childwin.focus();
  };
  return (
    <Row justify="center">
      <Col xl={4} lg={5} md={5} xs={24} sm={24} className="nav-card" style={{ marginTop: "7px" }}>
        <NavigationWrapper>
          <Row>
            <Col span={24} className="collection-header">
              <h6
                className={"nav-heading text-left"}
                style={{ paddingLeft: "10px" }}
              >
                MY ACCOUNT
              </h6>
            </Col>
          </Row>
          <Row justify="middle" style={{ marginTop: "-20px" }}>
            <Col className="collection-item" span={24}>
              <p
                style={{
                  borderColor: pathname.includes("dashboard") && "#09c1b2",
                }}
                className={
                  pathname.includes("dashboard")
                    ? "item-link text-left item-active"
                    : "item-link text-left "
                }
                onClick={() => history.push("/dashboard")}
              >
                Account Dashboard
              </p>
            </Col>
            <Col className="collection-item" span={24}>
              <p
                style={{
                  borderColor: pathname.includes("address") && "#09c1b2",
                }}
                className={
                  pathname.includes("address")
                    ? "item-link text-left item-active"
                    : "item-link text-left"
                }
                onClick={() => history.push("/address")}
              >
                Address Book
              </p>
            </Col>
            <Col className="collection-item" span={24}>
              <p
                onClick={() => history.push("/order")}
                style={{
                  borderColor: pathname.includes("order") && "#09c1b2",
                }}
                className={
                  pathname.includes("order")
                    ? "item-link text-left item-active"
                    : "item-link text-left"
                }
              >
                My Orders
              </p>
            </Col>
            <Col className="collection-item" span={24}>
              <p
                style={{
                  borderColor: pathname.includes("payment") && "#09c1b2",
                }}
                className={
                  pathname.includes("payment")
                    ? "item-link text-left item-active"
                    : "item-link text-left"
                }
                onClick={() => history.push("/payment")}
              >
                Payment Settings
              </p>
            </Col>
            <Col className="collection-item" span={24}>
              <p
                style={{
                  borderColor: pathname.includes("logout") && "#09c1b2",
                }}
                className={
                  pathname.includes("logout")
                    ? "item-link text-left item-active"
                    : "item-link text-left"
                }
                onClick={() => {
                  let domain = ".main-frame.com";
                  // let domain = "localhost";


                  cookies.remove("contractor_credentials", {
                    path: "/",
                    domain,
                  });
                  window.localStorage.clear();
                  window.location.reload();
                }}
              >
                Logout
              </p>
            </Col>
          </Row>
        </NavigationWrapper>
        <Row align="middle" style={{ marginTop: "15px" }}>
          <Col
            span={23}
            onClick={() => {
              window.open("/#/customer/rmx", "_blank");
            }}
          >
            <Card
              style={{
                backgroundColor: '#494A8B',
                position: 'relative',
                transition: 'box-shadow .25s',
                margin: '0.5rem 0 1rem 0',
              }}
              className="pointer-cursor"
            >
              <Row align="end" justify="space-between" style={{ alignItems: 'center' }}>
                <Col span={20} style={{ paddingLeft: '20px', lineHeight: '2rem' }} className="text-left" >
                  <span
                    style={{
                      fontSize: "22px",
                      fontWeight: "800",
                      marginRight: "5px",
                      color: "white",
                    }}
                    className="text-left"
                  >
                    Plant
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "white",
                    }}
                    className="text-left"
                  >
                    Directory
                  </span>
                </Col>
                <Col span={4} className="text-left">
                  <span className="text-left">
                    <VscLinkExternal size={"20"} color="white" />
                  </span>
                </Col>
              </Row>
            </Card>
          </Col>
          <Col span={23} onClick={() => window.open("https://surface-tech.com/etools/trkr-video/")}>
            <Card
              style={{
                backgroundColor: '#38C1B2',
                position: 'relative',
                transition: 'box-shadow .25s',
                margin: '0.5rem 0 1rem 0',
              }}
              className="pointer-cursor "
            >
              <Row align="middle" justify="space-between" style={{ alignItems: 'center' }} >
                <Col span={20} style={{ paddingLeft: '20px', lineHeight: '2rem' }} className="text-left" >
                  <span
                    style={{
                      fontSize: "20px",
                      fontWeight: "800",
                      marginRight: "5px",
                      color: "white",
                    }}
                    className="text-left"
                  >
                    TRKR
                  </span>
                  <span
                    style={{
                      fontSize: "12px",
                      color: "white",
                      marginTop: "-5px",
                    }}
                    className="text-left"
                  >
                    Tutorial
                  </span>
                </Col>
                <Col span={4} className="text-left" >
                  <span className="text-right">
                    <VscLinkExternal size={"20"} color="white" />
                  </span>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Col >
      <Col span={18}>{props.children}</Col>
      {
        pathname.includes("dashboard") && (
          <Col span={24} style={{ marginTop: "15px" }}>
            <img src={CustomerImage} width={"91%"} />
          </Col>
        )
      }
    </Row >
  );
}
